import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import moment from 'moment'
import editPencil from "assets/svgs/editPencilBlue.svg"
import { IconButton } from '@mui/material'

const DateWrapper = styled.div`
  width: 341px;
  position: relative;
`
const Input = styled.input`
    display: flex;
    width: 80%;
    margin-top: 24px;
    border: 1px solid #436AB2;
    border-radius: 6px;
    padding: 5px;
    justify-content: left;
    height: 50px;
    margin-right: 20px;
    outline: none;
    font-size: medium;
    padding-left: 18px;
    background-color: transparent !important;
`
const BorderDiv = styled.div`
    display: flex;
    flex-direction: row;
    margin-top: 24px;
    border: 1px solid #436AB2;
    border-radius: 6px;
    margin-right: 20px;
`
const InnerInput = styled.input`
    display: flex;
    width: 86%;
    padding: 5px;
    justify-content: left;
    height: 46px;
    outline: none;
    font-size: medium;
    padding-left: 18px;
    border: none;
    border-radius: 6px;
`
const Error = styled.p`
  color: red;
  font-size: 1.4rem;
  margin-top: 0.8rem;
  z-index: 9;
  position: absolute;
`
const ImageDiv = styled.img`
    padding-left:5px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`
const DatefieldWithIcon = ({ value, error, placeholder, onSelect, hideIcon, ...restProps }) => {
    const [disabled, setDisabled] = useState(true)
    useEffect(()=>{
      if(!value){
        setDisabled(false)
        console.log()
      }
    },[value])
    const age = ( function (DateParam){
    if (!DateParam || DateParam.length !== 10) return
    let age = moment().diff(moment(DateParam.split('/').reverse().join(), 'YYYYMMDD'), 'years') 
    if (age && age <=120)
    return age
    })(value)
    const selection = (boolean)=> {
      setDisabled(boolean);
      onSelect(boolean)
    }

  return (
    <DateWrapper>
        <BorderDiv>
            <InnerInput name="date" type="text" size='10' placeholder={placeholder} value={value} disabled={disabled} {...restProps} />
            {/* <ImageDiv src={editPencil} onClick={()=>setDisabled(false)}/> */}
            {!hideIcon && <IconButton aria-label="copy" color="primary" padding= '0' >
                <img src={editPencil} onClick={()=>selection(false)}/>
            </IconButton>}
        </BorderDiv>
        {error && <Error>{error}</Error>}
    </DateWrapper>
  )
}

export default DatefieldWithIcon
